import { Box } from "theme-ui";
import { useTranslations } from "../../../contexts/Translation";
import { InfoMessage } from "../../../components/InfoMessage/Index";
import { useUserManagement } from "./UserManagementContext";
import Button from "../../../components/Button";
import List from "../../../components/List/List";
import HeadingWithInfo from "../../../components/HeadingWithInfo/HeadingWithInfo";


type ComponentProps = {
  setShowGroups: (show: boolean) => void;
};

const GroupsSection = ({ setShowGroups }: ComponentProps ) => {
  const t = useTranslations('userManagementForm');
  const { groups } = useUserManagement();
  return (
    <Box>
      <HeadingWithInfo heading={t('groupsHeading')} info={t('groupsInfo')} />
      {  groups.length === 0 && <InfoMessage>{t('noGroups')}</InfoMessage> }
      { groups.length > 0 && <List items={groups.map(d => <Box>{d.name}</Box>)} /> }
      <Button onClick={() => setShowGroups(true)}>{t(groups.length === 0 ? 'addGroup': 'editGroups')}</Button>      
    </Box>
  );
};

export default GroupsSection;